import { HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ApiEndpoint } from '../../domain/models/api-endpoint.model';
import { ApiResponse } from '../../domain/models/api-response.model';
import { ProvetExplorerCapabilities } from '../../domain/models/provet-explorer-capabilities.model';
import { IProvetExplorerRepository } from '../../domain/repositories/provet-explorer.repository';
import { ProvetExplorerProxyRemoteDatasource } from '../datasources/remote/provet-explorer-proxy.remote-datasource';

@Injectable()
export class ProvetExplorerRepositoryImpl implements IProvetExplorerRepository {
  private readonly datasource = inject(ProvetExplorerProxyRemoteDatasource);

  public async request(
    endpoint: ApiEndpoint,
    pathParams: Readonly<Record<string, string>> = {},
    queryParams: Readonly<Record<string, string | number | boolean | undefined>> = {},
    body?: unknown,
  ): Promise<ApiResponse> {
    const response = await this.datasource.request(endpoint, pathParams, queryParams, body);
    return this.toApiResponse(response);
  }

  public async capabilities(): Promise<ProvetExplorerCapabilities> {
    const dto = await this.datasource.capabilities();
    return { mutationsEnabled: dto.MutationsEnabled === true };
  }

  private toApiResponse(response: HttpResponse<unknown>): ApiResponse {
    return {
      status: response.status,
      statusText: response.statusText,
      headers: new Map(response.headers.keys().map((name) => [name, response.headers.get(name) ?? ''])),
      body: response.body,
    };
  }
}
